/*import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";


function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function ActualBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth,
  forecastStart,
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
  forecastStart?: string;
}) {
  if (!item.actual) return null;

  const start = new Date(item.actual.start);
  const end = new Date(item.actual.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.actual.start);
  const endLabel = formatDate(item.actual.end);

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const durationDays =
    Math.ceil((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;

  // gray start date - 45 days
  const grayMinus45 = forecastStart
    ? new Date(new Date(forecastStart).getTime() - 45 * MS_PER_DAY)
    : null;

  // orange end date < gray start date - 45 days
  const showLeftLabels = grayMinus45 ? end < grayMinus45 : false;

  // inside labels only when bar is long AND not the left-side case
  const showInsideLabels = durationDays > 45 && !showLeftLabels;

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[28px] h-3 bg-orange-600 group z-20"
    : "absolute top-[28px] h-3 bg-orange-300 group z-20";

  const labelStyle: React.CSSProperties = {
    fontFamily: "Segoe UI, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    textShadow: "0 0 2px white",
  };
  

  return (
    <div className={barClass} style={{ left, width }}>
     
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>
          <div>
            <span className="font-semibold">Type:</span> Actual
          </div>
          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>
          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      

      {showInsideLabels ? (
        <div className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none">
          <span className="whitespace-nowrap text-black" style={labelStyle}>
            {startLabel}
          </span>
          <span className="whitespace-nowrap text-black" style={labelStyle}>
            {endLabel}
          </span>
        </div>
      ) : showLeftLabels ? (
        <div
          className="absolute top-1/2 right-[calc(100%+6px)] -translate-y-1/2 pointer-events-none text-black whitespace-nowrap"
          style={labelStyle}
        >
          <div>{startLabel}</div>
          <div>{endLabel}</div>
        </div>
      ) : (
        <div
          className="absolute top-1/2 right-[calc(100%+2px)] -translate-y-1/2 whitespace-nowrap pointer-events-none text-black"
          style={labelStyle}
        >
          {startLabel} to {endLabel}
        </div>
      )}
    </div>
  );
}*/
/*import type { CSSProperties } from "react";
import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";


function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function ActualBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth,
  forecastStart,
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
  forecastStart?: string;
}) {
  if (!item.actual) return null;

  const start = new Date(item.actual.start);
  const end = new Date(item.actual.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.actual.start);
  const endLabel = formatDate(item.actual.end);

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const durationDays =
    Math.ceil((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;

  const grayMinus45 = forecastStart
    ? new Date(new Date(forecastStart).getTime() - 45 * MS_PER_DAY)
    : null;

  const showLeftLabels = grayMinus45 ? end < grayMinus45 : false;
  const showInsideLabels = durationDays > 45 && !showLeftLabels;

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[28px] h-3 bg-orange-600 group z-20"
    : "absolute top-[28px] h-3 bg-orange-300 group z-20";

  // SAME PURE BLACK STYLE FOR ALL LABELS
  const labelStyle: CSSProperties = {
    fontFamily: "Segoe UI, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#000000",
    letterSpacing: "0.2px",
  };

  return (
    <div className={barClass} style={{ left, width }}>
     
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>

          <div>
            <span className="font-semibold">Type:</span> Actual
          </div>

          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>

          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      
      {showInsideLabels ? (
        <div className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none">
          <span className="whitespace-nowrap" style={labelStyle}>
            {startLabel}
          </span>

          <span className="whitespace-nowrap" style={labelStyle}>
            {endLabel}
          </span>
        </div>
      ) : showLeftLabels ? (
        <div
          className="absolute top-1/2 right-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
          style={labelStyle}
        >
          <div>{startLabel}</div>
          <div>{endLabel}</div>
        </div>
      ) : (
        <div
          className="absolute top-1/2 right-[calc(100%+2px)] -translate-y-1/2 whitespace-nowrap pointer-events-none"
          style={labelStyle}
        >
          {startLabel} to {endLabel}
        </div> 
      )}
    </div>
  );
}*/

import type { CSSProperties } from "react";
import { GanttWorkItem } from "../../types/gantt";
import { leftPx, widthPx } from "../../utils/ganttUtils";


function formatDate(value: string) {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

export function ActualBar({
  item,
  timelineStart,
  pxPerDay,
  timelineWidth,
  forecastStart,
}: {
  item: GanttWorkItem;
  timelineStart: Date;
  pxPerDay: number;
  timelineWidth: number;
  forecastStart?: string;
}) {
  if (!item.actual) return null;

  const start = new Date(item.actual.start);
  const end = new Date(item.actual.end);

  const left = leftPx(start, timelineStart, pxPerDay);
  const width = Math.max(widthPx(start, end, pxPerDay), 8);

  const startLabel = formatDate(item.actual.start);
  const endLabel = formatDate(item.actual.end);

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const durationDays =
    Math.ceil((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;

  const grayMinus45 = forecastStart
    ? new Date(new Date(forecastStart).getTime() - 45 * MS_PER_DAY)
    : null;

  const showLeftLabels = grayMinus45 ? end < grayMinus45 : false;
  const showInsideLabels = durationDays > 45 && !showLeftLabels;

  const isPositiveWorkId = item.workId > 0;

  const barClass = isPositiveWorkId
    ? "absolute top-[28px] h-3 bg-orange-600 group z-20"
    : "absolute top-[28px] h-3 bg-orange-300 group z-20";

 /* const labelNudge: CSSProperties = {
  transform: "translateY(2px)",
  lineHeight: 1,
};*/

  const outsideLabelStyle: CSSProperties = {
    //fontFamily: "Segoe UI, sans-serif",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#000000",
    letterSpacing: "0.2px",
  };

  const insideLabelStyle: CSSProperties = {
   // fontFamily: "Segoe UI, sans-serif",
   fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    color: "#FFFFFF",
    letterSpacing: "0.2px",
  };

  return (
    <div className={barClass} style={{ left, width }}>
     
      <div className="pointer-events-none absolute -top-14 left-1/2 -translate-x-1/2 z-50 hidden group-hover:block">
        <div className="rounded bg-gray-900 text-white text-xs px-3 py-2 shadow-lg whitespace-nowrap">
          <div>
            <span className="font-semibold">Work:</span> {item.workElement}
          </div>

          <div>
            <span className="font-semibold">Type:</span> Actual
          </div>

          <div>
            <span className="font-semibold">Start:</span> {startLabel}
          </div>

          <div>
            <span className="font-semibold">End:</span> {endLabel}
          </div>
        </div>
      </div>
      
     {showInsideLabels ? (
        <div className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none">
          <span className="whitespace-nowrap" style={insideLabelStyle}>
       {/*   <span className="gantt-text whitespace-nowrap" style={insideLabelStyle}> */}

            {startLabel}
          </span>

          <span className="whitespace-nowrap" style={insideLabelStyle}>
         {/* <span className="gantt-text whitespace-nowrap" style={insideLabelStyle}> */}

            {endLabel}
          </span>
        </div>
      ) : showLeftLabels ? (
        <div
          className="absolute top-1/2 right-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
          //className="gantt-text absolute top-1/2 right-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
          style={outsideLabelStyle}
        >
          <div>{startLabel}</div>
          <div>{endLabel}</div>
        </div>
      ) : (
        <div
          className="absolute top-1/2 right-[calc(100%+2px)] -translate-y-1/2 whitespace-nowrap pointer-events-none"
          //className="gantt-text absolute top-1/2 right-[calc(100%+2px)] -translate-y-1/2 whitespace-nowrap pointer-events-none"
          style={outsideLabelStyle}
        >
          {startLabel} to {endLabel}
        </div>
      )}
{/*{showInsideLabels ? (
  <div
    className="absolute inset-0 flex items-center justify-between px-1 pointer-events-none"
    style={labelNudge}
  >
    <span className="whitespace-nowrap" style={insideLabelStyle}>
      {startLabel}
    </span>
    <span className="whitespace-nowrap" style={insideLabelStyle}>
      {endLabel}
    </span>
  </div>
) : showLeftLabels ? (
  <div
    className="absolute top-1/2 right-[calc(100%+6px)] -translate-y-1/2 pointer-events-none whitespace-nowrap"
    style={{ ...outsideLabelStyle, transform: "translateY(1px) translateY(-50%)" }}
  >
    <div>{startLabel}</div>
    <div>{endLabel}</div>
  </div>
) : (
  <div
    className="absolute top-1/2 right-[calc(100%+2px)] -translate-y-1/2 whitespace-nowrap pointer-events-none"
    style={{ ...outsideLabelStyle, transform: "translateY(1px) translateY(-50%)" }}
  >
    {startLabel} to {endLabel}
  </div>
)}*/}


     
    </div>
  );
}
